import { useEffect, useState } from 'react'
import { FlickityOptions } from 'react-flickity-component'

const CarouselOptions: FlickityOptions = {
  dragThreshold: 20,
  pageDots: false,
  arrowShape: {
    x0: 25,
    x1: 60,
    y1: 35,
    x2: 65,
    y2: 30,
    x3: 35
  }
}

const positionButtonsInContainer = () => {
  const leftB = document.querySelector<HTMLButtonElement>('.flickity-prev-next-button.previous')
  const rightB = document.querySelector<HTMLButtonElement>('.flickity-prev-next-button.next')
  // adjust button positioning so that it fits inside bs container
  if (leftB && rightB) {
    leftB.style.left = '35px'
    rightB.style.right = '35px'
  }
}

const useFlickity = (
  className: string,
  options?: FlickityOptions & { fade?: boolean },
  packages?: {
    fade: boolean
    asNavFor: boolean
  }
) => {
  const [successfulLoad, setSuccessfulLoad] = useState(false)
  useEffect(() => {
    try {
      const Flickity = require('flickity')
      if (packages && packages.asNavFor) {
        require('flickity-as-nav-for')
      }
      if (packages && packages.fade) {
        require('flickity-fade')
      }
      new Flickity(className, {
        ...CarouselOptions,
        ...options
      })
      setSuccessfulLoad(true)
    } catch (error) {
      console.log(error)
    }
  }, [className, options, packages])

  return { successfulLoad }
}

export { useFlickity, CarouselOptions, positionButtonsInContainer }
